export const ROOT_URL = process.env.REACT_APP_API_URL
export const CANVAS_URL = process.env.REACT_APP_CANVAS_URL
export const API_ENDPOINTS = {
  auth: {
    signIn: '/cms/sign_in',
  },
}

export const constructUrlEndPoint = api => `${ROOT_URL}${api}`
